import { render } from "./AccountContent.vue?vue&type=template&id=31d46e96"
import script from "./AccountContent.vue?vue&type=script&lang=js"
export * from "./AccountContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__